import { Link } from "react-router-dom";
import { useLocalePath, useT } from "../../i18n";
import { Reveal } from "../Reveal";
import { Phrases } from "../Phrases";

export const ContactCta = ({ index = "07" }) => {
  const t = useT();
  const lp = useLocalePath();
  return (
    <section data-testid="contact-cta-section" className="bg-ink py-28 text-white sm:py-36 lg:py-48">
      <div className="container-x grid gap-12 lg:grid-cols-12 lg:items-end">
        <Reveal className="lg:col-span-8">
          <p className="eyebrow flex items-center gap-4 text-white/55">
            <span className="tabular-nums">{index}</span>
            <span className="h-px w-8 bg-current" aria-hidden />
            {t("contactCta.eyebrow")}
          </p>
          <h2 className="h-hero font-display mt-6" data-testid="contact-cta-title"><Phrases text={t("contactCta.title")} /></h2>
          <p className="mt-6 max-w-lg text-white/60">{t("contactCta.body")}</p>
        </Reveal>
        <Reveal delay={0.15} className="lg:col-span-4 lg:flex lg:justify-end">
          <Link to={lp("contact")} className="btn btn-light" data-testid="contact-cta-button">
            {t("contactCta.cta")}
          </Link>
        </Reveal>
      </div>
    </section>
  );
};
